import type { KapiDurumu, YazamamaSebebi as Sebep } from '@isg/validation';
import { SAPKA_ETIKET, sapkaListesiMetni } from '../i18n/tr';
import { YazamamaSebebi } from './YazamamaSebebi';

/**
 * KAPI SEBEBİ — YAZAMAYAN KULLANICININ TEK SATIRI, KAPININ ADIMLARINDAN
 * (yüzey dürüstlüğü turu · ikinci oturum, madde 219; Kapsam §20.3b P13).
 *
 * > **Ekran kural bilmez: sunucunun `…Kapisi` nesnesini okur.** Bayrak
 * > (`durum.yazabilir`) ve sebep (`durum.sebep`) aynı adım listesinden gelir;
 * > burada ne şapka listesi yazılır ne bahçe ne arşiv hesaplanır.
 *
 * Metin dört sebebin karşılığıdır:
 *   - **şapka** → *"<nesne> <sunucunun listesi> <fiil>."* — liste SUNUCUDAN
 *     (tenant ayarına bağlı kapılarda istemciye gömülemez), adlar i18n'den;
 *   - **bahçe** → *"Bu işyeri bahçenizde değil."*;
 *   - **elle bahçe** → *"Bu işyeri elle verilmiş bahçenizde değil."* (PTW onay
 *     havuzu — K-63);
 *   - **arşiv** → *"İşyeri arşivli: yeni kayıt açılmaz."*;
 *   - **durum** → kapının KENDİ cümlesi (sunucunun reddettiği metin);
 *   - **sahiplik** → *"<nesne> yalnız yükleyen ya da holding yöneticisi <fiil>."*
 *     (P13-c — ek silme; bölüm başına BİR KEZ, `ilkKapaliKapi` ile).
 *
 * ⚠️ Yazabilen kullanıcıya hiçbir şey çizilmez (kısıt cümlesi gürültüdür).
 * ⚠️ M1: tek satır, karar anında bilgi — kavram açıklaması yazılmaz.
 *
 * ⚠️ **ENVANTER:** bir dosyada `xKapisi.yazabilir` okunuyorsa aynı dosyada
 * `durum={…xKapisi}` ile bu bileşen çizilir (`yazma-kapisi-envanteri.spec`).
 */
export function kapiSebebiMetni(sebep: Sebep, nesne: string, fiil: string): string {
  switch (sebep.kod) {
    case 'sapka':
      return `${nesne} ${sapkaListesiMetni(sebep.sapkalar)} ${fiil}.`;
    case 'bahce':
      return 'Bu işyeri bahçenizde değil.';
    // PTW onay düğmesi (K-63): havuz yalnız ELLE bahçeyi okur — türetilen
    // bahçeyle izni gören kişiye "bahçenizde değil" denmez.
    case 'elle_bahce':
      return 'Bu işyeri elle verilmiş bahçenizde değil.';
    case 'arsiv':
      return 'İşyeri arşivli: yeni kayıt açılmaz.';
    case 'durum':
      return sebep.metin;
    // P13-c — ek silme kapısının sahiplik adımı (madde 227: yükleyen VEYA holding yön.).
    case 'sahiplik':
      return `${nesne} yalnız yükleyen ya da ${SAPKA_ETIKET.holding_admin} ${fiil}.`;
  }
}

export function KapiSebebi({
  durum,
  nesne,
  fiil,
  testId,
}: {
  durum: KapiDurumu;
  /** Şapka cümlesinin öznesi — ör. *"Lokasyonu"*. */
  nesne: string;
  /** Şapka cümlesinin fiili — ör. *"ekler"*. */
  fiil: string;
  testId: string;
}): React.JSX.Element | null {
  if (durum.yazabilir || durum.sebep === null) return null;
  return (
    <YazamamaSebebi testId={testId}>{kapiSebebiMetni(durum.sebep, nesne, fiil)}</YazamamaSebebi>
  );
}
